(function () {
  var page = document.querySelector("[data-wishlist-page]");
  if (!page) return;

  function slug() {
    if (window.WearableFavourites && WearableFavourites.shareSlugFromLocation) {
      return WearableFavourites.shareSlugFromLocation() || "";
    }
    try {
      var fromQuery = (new URLSearchParams(window.location.search).get("w") || "")
        .trim()
        .toLowerCase();
      return /^[a-f0-9]{24}$/.test(fromQuery) ? fromQuery : "";
    } catch (e) {
      return "";
    }
  }

  function itemsFromResponse(raw) {
    if (
      window.WearableFavourites &&
      typeof WearableFavourites.fromServerItems === "function"
    ) {
      return WearableFavourites.fromServerItems(raw || []);
    }
    return (raw || []).map(function (item) {
      return {
        id: String((item && (item.productId || item.id)) || ""),
        handle: (item && item.handle) || "",
        title: (item && item.title) || "",
        url: (item && item.url) || "",
        image: (item && item.image) || "",
        price: (item && item.price) || "",
        variantId: (item && item.variantId) || "",
      };
    });
  }

  function isRecipient() {
    return Boolean(slug());
  }

  function isLoggedIn() {
    return page.getAttribute("data-logged-in") === "true";
  }

  function items() {
    if (isRecipient()) return recipientItems;
    return window.WearableFavourites ? WearableFavourites.read() : [];
  }

  var recipientItems = [];
  var recipientError = false;

  function render() {
    var grid = page.querySelector("[data-wishlist-grid]");
    var status = page.querySelector("[data-wishlist-status]");
    var guestCta = page.querySelector("[data-wishlist-guest-cta]");
    var ownerCta = page.querySelector("[data-wishlist-owner-cta]");
    var intro = page.querySelector("[data-wishlist-intro]");
    if (!grid) return;

    var list = items();
    grid.replaceChildren();

    if (isRecipient() && recipientError) {
      if (status) {
        status.hidden = false;
        status.textContent =
          page.getAttribute("data-not-found-text") || "This wish list is not available.";
      }
      if (guestCta) guestCta.hidden = true;
      if (ownerCta) ownerCta.hidden = true;
      if (intro) intro.hidden = true;
      return;
    }

    if (!list.length) {
      if (status) {
        status.hidden = false;
        status.textContent = isRecipient()
          ? page.getAttribute("data-not-found-text") || "This wish list is not available."
          : page.getAttribute("data-empty-text") || "Your wish list is empty.";
      }
    } else if (status) {
      status.hidden = true;
    }

    list.forEach(function (item) {
      grid.appendChild(cardFor(item, !isRecipient()));
    });

    var hasItems = list.length > 0;
    if (guestCta) guestCta.hidden = isRecipient() || isLoggedIn();
    if (ownerCta) ownerCta.hidden = isRecipient() || !isLoggedIn() || !hasItems;
    if (intro && isRecipient()) intro.hidden = true;
  }

  function cardFor(item, canRemove) {
    var article = document.createElement("article");
    article.className = "collection-card";

    var media = document.createElement("div");
    media.className = "collection-card__media";
    var href = item.url || "/products/" + (item.handle || "");
    var link = document.createElement("a");
    link.className = "collection-card__link";
    link.href = href;
    if (item.image) {
      var img = document.createElement("img");
      var src = item.image;
      var src2x = src.replace(/([?&]width=)\d+\b/, "$11200");
      img.className = "collection-card__image";
      img.src = src;
      img.srcset = src2x !== src ? src + " 900w, " + src2x + " 1200w" : src;
      img.sizes =
        "(min-width: 990px) calc((100vw - 120px) * 0.25), calc((100vw - 60px) * 0.5)";
      img.alt = "";
      img.loading = "lazy";
      link.appendChild(img);
    }
    media.appendChild(link);

    if (canRemove) {
      var remove = document.createElement("button");
      remove.type = "button";
      remove.className = "collection-card__favourite is-active";
      remove.setAttribute("data-favourite-toggle", "");
      remove.setAttribute("data-product-id", String(item.id || ""));
      remove.setAttribute("data-product-handle", item.handle || "");
      remove.setAttribute("data-product-title", item.title || "");
      remove.setAttribute("data-product-url", href);
      remove.setAttribute("data-product-image", item.image || "");
      remove.setAttribute("data-product-price", item.price || "");
      remove.setAttribute("data-product-variant-id", item.variantId || "");
      remove.setAttribute("aria-label", "Remove");
      remove.textContent = "×";
      media.appendChild(remove);
    }

    article.appendChild(media);

    var meta = document.createElement("a");
    meta.className = "collection-card__meta";
    meta.href = href;
    var title = document.createElement("h3");
    title.className = "collection-card__title";
    title.textContent = item.title || item.handle || "";
    meta.appendChild(title);
    if (item.price) {
      var price = document.createElement("p");
      price.className = "collection-card__price";
      price.textContent = item.price;
      meta.appendChild(price);
    }
    article.appendChild(meta);

    if (item.variantId && window.WearableCart) {
      var bag = document.createElement("button");
      bag.type = "button";
      bag.className = "button button--outline button--small wishlist-page__bag";
      bag.textContent = page.getAttribute("data-add-to-bag") || "Add to Bag";
      bag.addEventListener("click", function () {
        WearableCart.addToCart(item.variantId, 1);
      });
      article.appendChild(bag);
    }

    return article;
  }

  function loadRecipient() {
    var id = slug();
    if (!id) return Promise.resolve();
    var base =
      (page.getAttribute("data-proxy-base") || "/apps/tryon") +
      "/wishlist.json?slug=" +
      encodeURIComponent(id);
    return fetch(base, { cache: "no-store" })
      .then(function (res) {
        if (!res.ok) throw new Error("not found");
        return res.json();
      })
      .then(function (data) {
        recipientItems = itemsFromResponse(data.items || []);
        recipientError = false;
        render();
      })
      .catch(function () {
        if (!isLoggedIn() || !window.WearableFavourites) {
          recipientItems = [];
          recipientError = true;
          render();
          return;
        }
        return fetch(
          (page.getAttribute("data-proxy-base") || "/apps/tryon") + "/wishlist.json",
          { cache: "no-store" },
        )
          .then(function (res) {
            if (!res.ok) throw new Error("not found");
            return res.json();
          })
          .then(function (data) {
            if (!data || data.shareSlug !== id || !data.shareEnabled) {
              throw new Error("not found");
            }
            recipientItems = itemsFromResponse(data.items || []);
            recipientError = false;
            render();
          })
          .catch(function () {
            recipientItems = [];
            recipientError = true;
            render();
          });
      });
  }

  document.addEventListener("favourites:updated", function () {
    if (!isRecipient()) render();
  });

  document.querySelectorAll("[data-wishlist-copy]").forEach(function (btn) {
    btn.setAttribute("data-copied-label", page.getAttribute("data-copied-text") || "Copied");
  });

  if (isRecipient()) {
    loadRecipient();
  } else {
    render();
  }
})();
